<template>
    <q-modal
      v-model="managerAffiliateModalOpen"
      class="sl-modal"
      :content-css="{minWidth: '30vw'}"
      :no-esc-dismiss="true"
      :no-backdrop-dismiss="true"
    >
      <q-modal-layout>
        <q-toolbar slot="header">
          <q-icon name="fa fa-user-plus"></q-icon>
          <q-toolbar-title>
            Add Manager
          </q-toolbar-title>
          <q-icon @click.native="onClose" :disabled="addingManagerToAffiliate" name="clear" />
        </q-toolbar>

        <div class="layout-padding">
          <div class="q-px-sm text-center">
            <h6>Find Manager</h6>
            <q-search v-model="filter">
              <q-autocomplete 
                ref="managerAutoComplete"
                stack-label="Search Managers"
                :debounce="500"
                :max-results="maxResults"
                @search="onSearchManager"
                :disabled="addingManagerToAffiliate"
                @selected="onSelectManager"
              />
            </q-search> 

            <div v-if="currentManagerAffiliateManager" style="margin-top:40px">
              <h6 style="font-size:15px;margin-bottom:5px">Selected Manager</h6>
              <div class="label green round action cursor-pointer" style="margin-left:-10px"><span>{{currentManagerAffiliateManager.item.USER_FIRST_NAME[0]}}{{currentManagerAffiliateManager.item.USER_LAST_NAME[0]}}</span></div>
              {{currentManagerAffiliateManager.item.USER_FIRST_NAME}} {{currentManagerAffiliateManager.item.USER_LAST_NAME}}
            </div>           
          </div>
        </div>
      <q-toolbar slot="footer">
        <q-toolbar-title></q-toolbar-title>
        <q-btn color="green" @click.native="addManagerAffiliateMethod()" :disabled="!currentManagerAffiliateManager || addingManagerToAffiliate">Add</q-btn>&nbsp;
        <q-btn @click.native="onClose" color="secondary" :disabled="addingManagerToAffiliate" outline>Cancel</q-btn>
      </q-toolbar>
      </q-modal-layout>
      <q-inner-loading v-if="addingManagerToAffiliate">
          <q-spinner-gears color="primary" size="70"></q-spinner-gears>
          <span>Adding Manager..</span>
      </q-inner-loading>
    </q-modal>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'ManagerAffiliateDialog',
  data(){
    return {
      maxResults: 10,
      filter: ''
    }
  },
  created(){
    this.setManagerAffiliate(null)
  },
  computed: {
    ...mapState('users', {
      managerAffiliateModalOpen: (state) => state.managerAffiliateModalOpen,
      currentManagerAffiliateManager: s => s.currentManagerAffiliateManager,
      addingManagerToAffiliate: s => s.addingManagerToAffiliate
    }),
    ...mapGetters('users', [
      'managerAutoCompleteOptions'
    ])
  },
  methods: {
    ...mapMutations('users', [
      'updateManagerAffiliateModalOpen',
      'setManagerAutoCompleteList',
      'setManagerAffiliate'
    ]),
    ...mapActions('users', [
      'addManagerAffiliate'
    ]),
    onClose () {
      this.updateManagerAffiliateModalOpen(false)
    },
    addManagerAffiliateMethod(){
      this.addManagerAffiliate(this)
    },
    onSearchManager (s, done) {
      let vm = this
      vm.$store.dispatch('users/fetchManagerAutoComplete', { s })
        .then( payload => {
          console.log(payload)
          vm.setManagerAutoCompleteList({managers: payload})
          done(this.managerAutoCompleteOptions)
        })
    },
    onSelectManager(manager){
      this.setManagerAffiliate(manager)
    }
  }
}
</script>

<style lang="stylus">
</style>
